import { bodyRequest, getRequest } from "@react/helpers/fetch"

// A refused change (422 { error }) rejects, so callers roll their optimistic update back.
const unwrap = promise => promise.then(json => {
  if (json && json.error) throw new Error(json.error)
  return json
})

const api = {
  get:   url         => unwrap(getRequest(url)),
  post:  (url, body) => unwrap(bodyRequest({ url, body, method: "POST" })),
  patch: (url, body) => unwrap(bodyRequest({ url, body, method: "PATCH" })),
}

export default api
